<template>
  <main>
    <form-filter-export :type_export="['excel']" @onExport="exportSales">
      <template #default>
        <b-form-group v-if="!isSales" label="Sales " class="mr-2">
          <v-select :options="salesOptions" v-model="dataExport.sales_id" label="text" :reduce="option => option.value"></v-select>
        </b-form-group>
        <b-form-group label="Konsumen (opsional)">
          <v-select :options="konsumenOptions" v-model="dataExport.konsumen_id" label="text" :reduce="option => option.value"></v-select>
        </b-form-group>
      </template>
    </form-filter-export>
    <b-overlay :show="loading">
      <b-card>
        <b-row class="align-items-center">
          <b-col sm="12" md="6" class="my-1">
            <section v-if="allowCreate() || isSales()" class="d-flex align-items-center">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                @click.prevent="$router.push('/penjualan/create')"
              >
                <feather-icon icon="PlusIcon" class="mr-50" />
                Tambah
              </b-button>
            </section>
          </b-col>
          <b-col sm="12" md="6" class="d-flex justify-content-end">
            <h2 class="text-danger text-right">
              Total: <strong>Rp {{ formatRupiah(sumTotalBayar) }}</strong>
            </h2>
          </b-col>
        </b-row>
        <b-row class="align-items-end">
          <b-col md="2" sm="4" class="my-1">
            <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              />
            </b-form-group>
          </b-col>
          <b-col md="5" sm="8" class="my-1">
            <b-form-group label="Cari" label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Cari no. nota / nama konsumen..."
                  @keyup.enter="applySearch"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearSearch">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-table
              striped
              small
              hover
              responsive
              :items="items"
              :fields="fields"
              :busy="loading"
            >
              <template #cell(no)="{ index }">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </template>
              <template #cell(sales)="{ item }">
                {{ item.sales ? item.sales.nama_lengkap : "-" }}
              </template>
              <template #cell(konsumen)="{ item }">
                {{ item.konsumen ? item.konsumen.nama_toko : "-" }}
              </template>
              <template #cell(status)="{ item }">
                <b-badge v-if="item.is_cancelled" variant="secondary">DIBATALKAN</b-badge>
                <b-badge v-else-if="item.status == 1" variant="success">LUNAS</b-badge>
                <b-badge v-else variant="danger">BELUM LUNAS</b-badge>
              </template>
              <template #cell(bayar)="{ item }">
                <b-badge v-if="item.is_cancelled" variant="secondary">DIBATALKAN</b-badge>
                <b-badge v-else-if="item.bayar == 1" variant="success">SUDAH BAYAR</b-badge>
                <b-badge v-else variant="danger">BELUM BAYAR</b-badge>
              </template>
              <template #cell(total_bayar)="{ item }">
                <strong
                  >Rp
                  {{
                    formatRupiah(item.total_bayar)
                  }}</strong
                >
              </template>

              <template #cell(action)="{ item }">
                <b-button
                  size="sm"
                  variant="warning"
                  @click.prevent="$router.push(`/penjualan/detail/${item.id}`)"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
                <b-button
                  v-if="!item.is_cancelled && item.status == 0 && allowUpdate() && item.tak_tertagih == 0 && item.bayar == 0"
                  size="sm"
                  variant="outline-warning"
                  @click.prevent="$router.push(`/penjualan/edit/${item.id}`)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
              </template>
            </b-table>
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </main>
</template>

<script>
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormFilterExport from '@core/components/form-filter-export/FormFilterExport.vue'
import {
  BTable,
  BCard,
  VBTooltip,
  BDropdown,
  BDropdownItem,
  BAvatar,
  BBadge,
  BModal,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormCheckbox,
  BOverlay,
} from "bootstrap-vue";
import vSelect from 'vue-select'
import mixin from "./mixin";

export default {
  mixins: [mixin],
  components: {
    ToastificationContent,
    FormFilterExport,
    VBTooltip,
    BModal,
    BDropdown,
    BDropdownItem,
    BTable,
    BCard,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    BOverlay,
    vSelect
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: false,
      searchApplied: "",
      sumTotalBayar: 0,
      showModalEdit: false,
      showModalTambah: false,
      id: null,
      form: {
        blok: null,
        gudang_id: null,
      },
      dataGudang: [],
      perPage: 10,
      pageOptions: [10, 30, 50, 100],
      totalRows: 0,
      currentPage: 1,
      filter: null,
      dataExport: {
        konsumen_id: null,
        sales_id: null
      },
      fields: [
        {
          key: "no",
          label: "No",
        },
        { key: "no_kwitansi", label: "No. Nota" },
        { key: "konsumen.type_konsumen.nama", label: "Jenis Konsumen" },
        { key: "konsumen", label: "Konsumen" },
        { key: "sales", label: "Sales" },
        { key: "tanggal", label: "Tanggal Transaksi" },
        { key: "status", label: "Status Transaksi" },
        { key: "bayar", label: "Status Pembayaran" },
        { key: "total_bayar", label: "Total Penjualan" },
        { key: "action", label: "#" },
      ],
      items: [],
      salesOptions: [],
      konsumenOptions: []
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getData();
      }
    },
  },
  methods: {
    applySearch() {
      this.searchApplied = this.filter ? String(this.filter).trim() : "";
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getData();
      }
    },
    clearSearch() {
      this.filter = "";
      this.searchApplied = "";
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getData();
      }
    },
    async exportSales({tgl_awal, tgl_akhir, type_export}) {
      if(!tgl_awal || !tgl_akhir) {
        this.displayError({
          message: 'Harap isi tanggal awal dan akhir!'
        })
        return false
      }
      
      // validate type_export pdf || excel
      const params = {
        tgl_awal,
        tgl_akhir,
        type_export
      }
      if(this.isSales && this.myGudang) params.sales_id = this.user && this.user.karyawan ? this.user.karyawan.id : null
      if(this.dataExport.konsumen_id) params.konsumen_id = this.dataExport.konsumen_id
      if(this.dataExport.sales_id) params.sales_id = this.dataExport.sales_id

      try {
        this.loading = true
        const response = await this.printSales(params)
        this.loading = false
        if(type_export == 'pdf') {
          window.open(URL.createObjectURL(response))
        }
        else {
          await window.open(response)
          setTimeout(async () => {
            // delete selected file
            const arrFile = response.split('/')
            const filename = arrFile[ arrFile.length - 1 ]

            await this.clearExportedFile(filename)
          }, 1000)
        }
      }
      catch(e) {
        console.error(e)
        this.loading = false
        this.displayError(e)
        return false
      }
    },
    async getKonsumen() {
      const params = {
        order: 'desc'
      }
      if(this.isSales) {
        params.karyawan_id = this.user.karyawan.id
        params.status = 3 // disetujui
      }
      else {
        params.status = 3
      }

      const konsumens = await this.$store.dispatch('ajuankonsumen/getData', params)
      this.konsumenOptions = konsumens.map(item => ({value: item.id, text: item.nama_owner}))
    },
    async getSales() {
      const levels = await this.$store.dispatch('level/getData', {
          search: 'sales'
      })
      const salesLevel = levels.find(level => this.getShortName(level.nama_level) == 'sales')
      const params = {}
      if(salesLevel) params.level_id = salesLevel.id

      const sales = await this.$store.dispatch('pengguna/getData', params)
      this.salesOptions = sales.map(item => ({
          value: item.karyawan.id,
          text: item.karyawan.nama_lengkap
      }))
    },
    async getData() {
      const params = {
        order: "desc",
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      };
      if (this.isSales && this.user && this.user.karyawan) {
        params.id_sales = this.user.karyawan.id;
      }
      if (this.searchApplied) {
        params.search = this.searchApplied;
      }

      this.loading = true;
      try {
        const result = await this.$store.dispatch("penjualan/getData", params);
        this.items = Array.isArray(result) ? result.slice() : [];
        this.totalRows =
          result && result.total != null ? result.total : this.items.length;
        this.sumTotalBayar =
          result && result.sum_total_bayar != null
            ? Number(result.sum_total_bayar)
            : 0;
      } catch (e) {
        this.displayError(e);
        this.items = [];
        this.totalRows = 0;
        this.sumTotalBayar = 0;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getKonsumen()
    if (this.isSales) {
      this.fields = [
        {
          key: "no",
          label: "No",
        },
        { key: "no_kwitansi", label: "No. Nota" },
        { key: "konsumen.type_konsumen.nama", label: "Jenis Konsumen" },
        { key: "konsumen", label: "Konsumen" },
        { key: "tanggal", label: "Tanggal Transaksi" },
        { key: "status", label: "Status Transaksi" },
        { key: "bayar", label: "Status Pembayaran" },
        { key: "total_bayar", label: "Total Penjualan" },
        { key: "action", label: "#" },
      ];
    } else {
      this.getSales()
      this.fields = [
        {
          key: "no",
          label: "No",
        },
        { key: "no_kwitansi", label: "No. Nota" },
        { key: "konsumen.type_konsumen.nama", label: "Jenis Konsumen" },
        { key: "konsumen", label: "Konsumen" },
        { key: "sales", label: "Sales" },
        { key: "tanggal", label: "Tanggal Transaksi" },
        { key: "status", label: "Status Transaksi" },
        { key: "bayar", label: "Status Pembayaran" },
        { key: "total_bayar", label: "Total Penjualan" },
        { key: "action", label: "#" },
      ];
    }
    this.getData();
  },
};
</script>
